import React from 'react';
import './index.less';

interface SidebarHeaderProps {
  collapsed?: boolean;
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({ collapsed }) => {
  return (
    <div className={`sidebar-header ${collapsed ? 'collapsed' : ''}`}>
      <div className="logo-container">
        <img src="/EB Logo_PNG 1.png" alt="Logo" className="logo-image" />
      </div>
    </div>
  );
};

export default SidebarHeader;
